import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.PACKAGES.SERVER

export function createServerPackage(data) {
    return apiHelper({ method: "post", path: pathBase.CREATE, data })
}

export function editServerPackage(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteServerPackage(packageId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { packageId } })
}

export function getServerPackageList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
